import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { AiReceptionistCall } from '../../models/AiReceptionist';

export interface AiReceptionistCallsResponse {
  calls: AiReceptionistCall[];
  // Next page bound of each subscription that still has calls, null once they are all exhausted
  next_cursors: Record<string, number> | null;
}

interface GetCompanyAiReceptionistCallsPayload {
  company_id: string;
  start: number;
  end: number;
  cursors?: Record<string, number>;
}

export async function getCompanyAiReceptionistCalls(
  payload: GetCompanyAiReceptionistCallsPayload,
  auth: Authentication,
): Promise<AiReceptionistCallsResponse> {
  try {
    if (!payload.company_id) {
      throw new GetCompanyAiReceptionistCallsFailure('company_id est requis');
    }

    const response = await HttpClient.post('/company/ai-receptionist/calls', payload, auth.token);

    return response.data as AiReceptionistCallsResponse;
  } catch (e) {
    console.error('getCompanyAiReceptionistCalls error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyAiReceptionistCallsFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyAiReceptionistCallsFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyAiReceptionistCallsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
